import Button, { IconButton } from '@components/shared/Button'
import Modal from '@components/shared/Modal'
import OpenExplorerLinkIcon from '@components/shared/OpenExplorerLinkIcon'
import { TrashIcon } from '@heroicons/react/20/solid'
import { useLocalStorage } from 'hooks/useLocalStorageState'
import { ExternalLink } from '@components/shared/ExternalLink'
import { useState } from 'react'
import { ModalProps } from 'types/modal'
import { REFERRER_KEY, makeWalletExplorerUrl } from 'utils/constants'
import { abbreviateAddress } from 'utils/formatting'
import { tryGetPubKey } from 'utils/governance/tools'
import { useTranslation } from 'next-i18next'

const ReferrerSettings = () => {
  const { t } = useTranslation('settings')
  const [localReferrer] = useLocalStorage(REFERRER_KEY)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  return (
    <>
      <div className="flex flex-row items-center justify-between border-y border-th-bkg-3 p-4">
        <p className="text-th-fgd-1">{t('your-referrer')}</p>
        <div className="flex items-center gap-3">
          {localReferrer?.wallet && tryGetPubKey(localReferrer.wallet) ? (
            <>
              <div>
                <p className="text-right text-th-fgd-1">{localReferrer.name}</p>
                <p className="text-right text-xs">
                  {abbreviateAddress(localReferrer.wallet)}
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <ExternalLink
                  href={makeWalletExplorerUrl(localReferrer.wallet)}
                  className="text-th-fgd-3 md:hover:text-th-fgd-2"
                >
                  <OpenExplorerLinkIcon className="size-5" />
                </ExternalLink>
                <IconButton
                  className="text-th-fgd-3 md:hover:text-th-fgd-2"
                  onClick={() => setIsDeleteModalOpen(true)}
                >
                  <TrashIcon className="size-5" />
                </IconButton>
              </div>
            </>
          ) : (
            <p className="text-th-fgd-1">{t('none')}</p>
          )}
        </div>
      </div>
      {isDeleteModalOpen ? (
        <ConfirmDeleteModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
        />
      ) : null}
    </>
  )
}

export default ReferrerSettings

const ConfirmDeleteModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('settings')
  const [, setLocalReferrer] = useLocalStorage(REFERRER_KEY)
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mb-6 flex flex-col items-center">
        <h2 className="mb-2 text-center">{t('delete-referrer-modal.title')}</h2>
        <p className="text-center">{t('delete-referrer-modal.message')}</p>
      </div>
      <Button
        className="w-full"
        onClick={() => {
          setLocalReferrer(null)
          onClose()
        }}
      >
        {t('delete-referrer-modal.confirm-button')}
      </Button>
    </Modal>
  )
}
